import {
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    Modal,
    Drawer,
    notification,
    Row,
    Select,
    Table,
    Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import { Editor } from 'react-draft-wysiwyg'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {
    ArticleTypeList,
    chooseEmailModalFxn,
    Countries,
    CustomCkEditor,
    DesignationList,
    InputBox,
    mentionsFeeds,
    NotificationBox,
    ProcessList, YearArr, YearArr2, paymentModeList, copiesList
} from '../../../components/_utils/appUtils'
import { CountriesList, JournalList } from '../../journals/actions'
import { singleOnlineSubmission } from '../../onlineSubmission/actions'
import { addMember, checkMemberEmails } from '../../members/actions'
import { addSubscriptionActivityFxn, updateGeneralSubscriptionFxn, addJournalToSubscriptionFxn } from '../action'
import { getGroupedSubscription, journalsAjaxList } from '../../subscription/actions'
import Request from '../../../request'

@Form.create()
class EditGeneralSubscriptionDrawer extends PureComponent {
    state = {
        name: '',
        journalListArr: [],
        email: '',
        state: '',
        totalAmount: '',
        journals: [],
        journalName: '',
        country: '',
        city: '',
        subscribedBy: '',
        yearOptions: [],
        pincode: '',
        pageNumber: '',
        endUserAddress: '',
        copies: '',
        designation: '',
        contactPerson: '',
        agencyName: '',
        subscriptionData: {},
        journalList: [],
        multipleJournals: [],
        amountDetails: [],
        distinctYears: [],
        journalVolumeList: [],
        journalIssueList: [],
        volume: undefined,
        issue: undefined
    }
    paymentDetails = {
        receivedDate: '',
        modeOfPayment: '',
        amount: '',
        year: ''

    }

    constructor(props) {
        super(props)

    }

    resetFormData = () => {
        const { dispatch, form } = this.props
        form.setFieldsValue({
            journals: [],
            name: '',
            email: '',
            country: '',
            state: '',
            city: '',
            pincode: '',
            subscribeBy: '',
            address: '',
            mobile: '',
            instituteName: '',
            instituteContactPerson: '',
            instituteContactNo: '',
            instituteAddress: '',
            copies: ''
        })
    }
    handleSubmit = e => {
        const { dispatch, form, record } = this.props
        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                valData.amountDetails = this.state.amountDetails
                valData.totalAmount = this.state.totalAmount
                valData.journals = this.state.journals

                let response;
                if (this.props.showAddJournal) {
                    response = await dispatch(addJournalToSubscriptionFxn(record._id, valData))
                } else {
                    response = await dispatch(updateGeneralSubscriptionFxn(record._id, valData))
                }



                if (response && !response.error) {
                    notification.success({
                        message: "Subscription updated successfully"
                    })

                    this.resetFormData()

                    this.props.onClose()
                    if (this.props.onSuccess) {
                        this.props.onSuccess()
                    }

                    this.setState({
                        name: '',
                        email: '',

                    })
                } else {

                    notification.error({
                        message: "Failed to update subscription"
                    })
                }

            }
        })
    }
    componentDidMount() {

        this.loadJournalList();
        this.apiGroupedSubscription();
        this.journalAjax();

        const { record, form, showAddJournal } = this.props;

        if (record) {
            this.setState({
                // amountDetails: repairedDetails, // Only if NOT adding journal
                // totalAmount: record.totalAmount || calculatedTotal
            });

            setTimeout(() => {
                form.setFieldsValue({
                    subscribeBy: record.subscribeBy,
                });
                setTimeout(() => {
                    form.setFieldsValue({
                        name: record.name,
                        email: record.email,
                        secondaryEmail: record.secondaryEmail,
                        mobile: record.mobile,
                        secondaryMobile: record.secondaryMobile,
                        address: record.address,
                        pincode: record.pincode,
                        country: record.country,
                        state: record.state,
                        city: record.city,
                        pageNumber: record.pageNumber,
                        year: record.year,
                        instituteContactPerson: record.instituteContactPerson || record.contactPerson,
                        contactPerson: record.contactPerson
                    });
                }, 100);
            }, 100);
        }

        if (showAddJournal) {
            this.setState({ amountDetails: [], totalAmount: 0 });
        }
        else if (record) {
            const rawDetails = record.amountDetails || [];
            const repairedDetails = this.repairAmountDetails(rawDetails, this.state.journalList);
            const calculatedTotal = repairedDetails.reduce((acc, item) => {
                const itemTotal = item.totalForSub || (item.priceInInr * (parseInt(item.copies) || 1));
                return acc + (itemTotal || 0);
            }, 0);

            console.log("DEBUG: componentDidMount setFormValuesFxn initial calc:", calculatedTotal);

            this.setState({
                amountDetails: repairedDetails,
                totalAmount: record.totalAmount || calculatedTotal
            });
        }
    }

    componentDidUpdate(prevProps) {
        if ((this.props.visible && !prevProps.visible) || (this.props.record !== prevProps.record)) {
            const { record, form, showAddJournal } = this.props;


            if (record) {
                setTimeout(() => {
                    form.setFieldsValue({
                        subscribeBy: record.subscribeBy,
                    });
                    console.log('DEBUG: Set subscribeBy:', record.subscribeBy);
                    setTimeout(() => {
                        form.setFieldsValue({
                            name: record.name,
                            email: record.email,
                            secondaryEmail: record.secondaryEmail,
                            mobile: record.mobile,
                            secondaryMobile: record.secondaryMobile,
                            address: record.address,
                            pincode: record.pincode,
                            country: record.country,
                            state: record.state,
                            city: record.city,
                            pageNumber: record.pageNumber,
                            year: record.year,
                            instituteContactPerson: record.instituteContactPerson || record.contactPerson,
                            contactPerson: record.contactPerson
                        });
                        console.log('DEBUG: Set other fields. Name:', record.name);
                    }, 100);
                }, 100);
            }

            if (showAddJournal) {
                this.setState({ amountDetails: [], totalAmount: 0 });
            }
            else if (record) {
                const rawDetails = record.amountDetails || [];
                const repairedDetails = this.repairAmountDetails(rawDetails, this.state.journalList);

                const calculatedTotal = repairedDetails.reduce((acc, item) => {
                    const itemTotal = item.totalForSub || (item.priceInInr * (parseInt(item.copies) || 1));
                    return acc + (itemTotal || 0);
                }, 0);

                this.setState({
                    amountDetails: repairedDetails,
                    totalAmount: record.totalAmount || calculatedTotal
                }, () => {
                    this.repairAndRecalculate();
                });
            }
        }
    }

    events = {
        removeStateCountry: (index) => {
            let cloneArr = _.clone(this.state.amountDetails);
            cloneArr.splice(index, 1);
            const { year } = this.state;

            const { total, amountDetails } = this.calculateTotalAmount(cloneArr);

            this.setState({
                amountDetails,
                totalAmount: total
            });
        }
    }


    calculateTotalAmount = (multipleJournals) => {
        const { subscriptionData, journalList } = this.state;
        let total = 0;
        const amountDetails = [];
        const journalArray = [];

        if (!multipleJournals || multipleJournals.length === 0) {
            return { total, amountDetails };
        }
        multipleJournals.forEach(item => {
            let { journalName, copies, year, volume, issue } = item;
            const journals = item.journals || item.journalId;
            const journalSubs = subscriptionData[journals] || [];
            const sub = journalSubs.find(s => s.year === year);

            if (!journalName && journals && journalList) {
                const foundJournal = journalList.find(j => j._id === journals);
                if (foundJournal) {
                    journalName = foundJournal.name;
                }
            }

            let priceInInr = 0;
            if (sub) {
                priceInInr = sub.priceInInr;
            } else if (item.priceInInr) {
                priceInInr = item.priceInInr;
            }

            const copiesCount = parseInt(copies, 10) || 1;
            const totalForSub = priceInInr * copiesCount;

            total += totalForSub;
            amountDetails.push({
                journals,
                journalId: journals,
                journalName,
                copies: copiesCount,
                priceInInr,
                totalForSub,
                year,
                volume,
                issue
            });
            journalArray.push(journals)
        });

        this.setState({ journals: journalArray })
        return { total, amountDetails };
    };
    loadJournalList = async () => {
        const { dispatch, form } = this.props
        let { data } = await JournalList()
        this.setState({ journalListArr: data })
        form.setFieldsValue({ enterDate: moment() })
    }

    repairAmountDetails = (amountDetails, journalList) => {
        if (!amountDetails || !journalList || journalList.length === 0) return amountDetails;

        return amountDetails.map(item => {
            if (!item.journalName && (item.journals || item.journalId)) {
                const id = item.journals || item.journalId;
                const found = journalList.find(j => j._id === id);
                if (found) {
                    return { ...item, journalName: found.name };
                }
            }
            return item;
        });
    }

    recalculateTotalFromDetails = (details) => {
        if (!details || details.length === 0) return 0;
        return details.reduce((acc, item) => {
            const itemTotal = item.totalForSub || (item.priceInInr * (parseInt(item.copies) || 1));
            return acc + (itemTotal || 0);
        }, 0);
    }

    journalAjax = async () => {
        let { dispatch } = this.props
        let { data } = await dispatch(journalsAjaxList())
        this.setState({ journalList: data }, () => {
            const { amountDetails, totalAmount, record } = this.state;
            if (amountDetails && amountDetails.length > 0) {
                const newDetails = this.repairAmountDetails(amountDetails, data);

                this.setState({ amountDetails: newDetails }, () => {
                    this.repairAndRecalculate();
                });
            }
        })
    }

    getJournalsVolumeData = async (id) => {
        try {
            let { data } = await Request.getJournalsVolumeList({ journalId: id })
            let volumeList = []
            _.each(data, (item) => {
                volumeList.push({
                    _id: item._id,
                    name: item.volumeName
                })
            })
            this.setState({ journalVolumeList: volumeList })
        } catch (error) {
            console.error(error)
        }
    }

    getJournalsIssueData = async (volumeId) => {
        try {
            const { form: { getFieldValue } } = this.props;
            let journal = getFieldValue('journals');

            let { data } = await Request.getJournalIssue({ journalId: journal, volumeId: volumeId })
            let issueList = []
            _.each(data, (item) => {
                issueList.push({
                    _id: item._id,
                    name: item.issueName
                })
            })
            this.setState({ journalIssueList: issueList })
        } catch (error) {
            console.error(error)
        }
    }

    repairAndRecalculate = () => {
        const { amountDetails, subscriptionData, journalList, totalAmount } = this.state;
        const { record } = this.props;
        if (!amountDetails || amountDetails.length === 0) return;

        console.log("DEBUG: repairAndRecalculate triggered");
        console.log("DEBUG: amountDetails:", JSON.stringify(amountDetails, null, 2));
        console.log("DEBUG: subscriptionData keys:", Object.keys(subscriptionData));

        let updated = false;

        const newDetails = amountDetails.map(item => {
            let newItem = { ...item };

            let rawId = newItem.journals || newItem.journalId;
            let journalId = null;

            if (!newItem.journalName) {
                console.log("DEBUG: Repairing Name. Raw ID:", rawId);
            }

            if (rawId) {
                if (typeof rawId === 'object') {
                    journalId = rawId._id || rawId.id || rawId;
                } else {
                    journalId = rawId;
                }
            }
            if (journalId && typeof journalId !== 'string') {
                if (journalId.toString() !== "[object Object]") {
                    journalId = journalId.toString();
                } else {
                    console.log("DEBUG: ID is still object object:", journalId);
                }
            }

            if (journalId) console.log("DEBUG: Derived Journal ID:", journalId);

            if (!newItem.journalName && journalList && journalId) {
                const found = journalList.find(j => j._id === journalId || j._id.toString() === journalId);
                if (found) newItem.journalName = found.name;
            }

            // Robust Year Retrieval
            if (!newItem.year) {
                if (record && record.year) newItem.year = record.year;
                else if (this.props.form) {
                    const formYear = this.props.form.getFieldValue('year');
                    if (formYear) newItem.year = formYear;
                }
            }

            if (!newItem.priceInInr || newItem.priceInInr === 0 || !newItem.volume || !newItem.issue) {
                const year = newItem.year;

                if (journalId) {
                    console.log(`DEBUG: Checking details for JournalId: ${journalId}, Year: ${newItem.year}`);

                    if (subscriptionData) {
                        let journalSubs = subscriptionData[journalId];
                        if (!journalSubs) {
                            const matchingKey = Object.keys(subscriptionData).find(k => k.toString() === journalId);
                            if (matchingKey) journalSubs = subscriptionData[matchingKey];
                        }

                        if (journalSubs) {
                            // Loose equality for year (string vs number)
                            const sub = journalSubs.find(s => s.year == newItem.year);
                            if (sub) {
                                console.log(`DEBUG: Found matching sub! Price: ${sub.priceInInr}, Volume: ${sub.volumeName}, Issues: ${sub.issues}`);
                                if (!newItem.priceInInr || newItem.priceInInr === 0) {
                                    newItem.priceInInr = sub.priceInInr;
                                    newItem.totalForSub = newItem.priceInInr * (parseInt(newItem.copies) || 1);
                                    updated = true;
                                }
                                if (!newItem.volume && sub.volumeName) {
                                    newItem.volume = sub.volumeName;
                                    updated = true;
                                }
                                if (!newItem.issue && (sub.issueName || sub.issues)) {
                                    newItem.issue = sub.issueName || sub.issues;
                                    updated = true;
                                }
                            } else {
                                console.log("DEBUG: No matching sub found for year.");
                            }
                        } else {
                            console.log("DEBUG: No subs found for this journal ID.");
                        }
                    }
                }
            }
            return newItem;
        });

        const newTotal = newDetails.reduce((acc, item) => {
            const val = item.totalForSub || (item.priceInInr * (parseInt(item.copies) || 1));
            return acc + (val || 0);
        }, 0);

        console.log(`DEBUG: Calculated New Total: ${newTotal}, Old Total: ${totalAmount}, Updated: ${updated}`);

        if (updated || !totalAmount || totalAmount === 0 || totalAmount !== newTotal) {
            this.setState({
                amountDetails: newDetails,
                totalAmount: newTotal
            });
        }
    }

    apiGroupedSubscription = async () => {
        let result = await getGroupedSubscription()
        const data = result.data || {};
        const allItems = Object.values(data).flat();
        const allYears = allItems.map(item => item.year);
        const distinctYears = [...new Set(allYears)];

        this.setState({
            subscriptionData: data,
            distinctYears: distinctYears
        }, () => {
            this.repairAndRecalculate();
        });
    }

    chooseDocument = e => {
        let { name, files } = e.target
        if (files && files.length) {
            this.setState({ [name]: files[0] })
        }

    }
    async AddSubscriptionDetails() {
        const {
            form: { getFieldValue, setFieldsValue }
        } = this.props;

        let journals = getFieldValue("journals");
        let copies = getFieldValue("copies");
        let year = getFieldValue("year");
        let volume = getFieldValue("volume");
        let issue = getFieldValue("issue");

        // In edit mode, Year field is hidden — fall back to the record's year
        if (!year && this.props.record && this.props.record.year) {
            year = this.props.record.year;
        }

        if (!journals) {
            notification.error({ message: "Please choose Journal Name." });
            return;
        }
        if (!copies) {
            notification.error({ message: "Please select copies" });
            return;
        }
        if (!year) {
            notification.error({ message: "Please choose Year." });
            return;
        }

        const journalObj = this.state.journalList.find(j => j._id === journals);

        let newItem = {
            journals,
            copies,
            year,
            volume: this.state.volume,
            issue: this.state.issue,
            journalId: journalObj._id,
            journalName: journalObj.name
        };
        let clone = _.cloneDeep(this.state.amountDetails);

        const existIndex = clone.findIndex(
            item => item.journals === journals && item.year === year
        );

        if (existIndex !== -1) {
            notification.error({
                message: 'This Journal for the selected Year is already added.'
            });
            return;
        } else {
            clone.push(newItem);
        }

        const { total, amountDetails } = this.calculateTotalAmount(clone);
        this.setState({ amountDetails, totalAmount: total });

        setFieldsValue({
            journals: undefined,
            copies: undefined,
            volume: undefined,
            issue: undefined
        });
        this.setState({ journalVolumeList: [], journalIssueList: [] });

    }

    render() {


        const {
            form: { getFieldDecorator, getFieldValue, setFieldsValue },
            loading
        } = this.props
        // Updated this logic :-
        const subscribeBy = getFieldValue('subscribeBy');

        let nameLabel = 'Name';
        let contactPersonLabel = 'Contact Person';

        if (['Institute', 'Agency', 'Library'].includes(subscribeBy)) {
            nameLabel = `${subscribeBy} Name`;
            contactPersonLabel = `${subscribeBy} Contact Person`;
        }

        const { edit, journalListArr, lastArticleNo, subscriptionData } = this.state
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
                md: { span: 24 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
                md: { span: 24 }
            }
        }


        const inputSchma = {
            fields: [
                {
                    label: 'Subscribe By',
                    key: 'subscribeBy',
                    required: true,
                    type: 'select', options: ['Institute', 'Agency', 'Library'],
                    onChange: val => {
                        setFieldsValue({
                            subscribeBy: val,
                            name: '',
                            email: '',
                            secondaryEmail: '',
                            mobile: '',
                            secondaryMobile: '',
                            address: '',
                            pincode: '',
                            country: undefined,
                            state: '',
                            city: '',
                            pageNumber: '',
                            contactPerson: '',
                            designation: '',
                            agencyName: '',
                            instituteName: '',
                            instituteContactPerson: '',
                            instituteAddress: '',
                            instituteContactNo: ''
                        })
                    }
                },
                {
                    label: nameLabel,
                    key: 'name',
                    required: true,
                    placeholder: nameLabel
                },
                {
                    label: contactPersonLabel,
                    key: 'instituteContactPerson',
                    required: true,
                    placeholder: contactPersonLabel,
                },
                {
                    label: 'Primary Email',
                    key: 'email',
                    required: true,
                    type: 'email',
                    placeholder: 'Primary Email'
                },
                {
                    label: 'Secondary Email',
                    key: 'secondaryEmail',
                    required: false,
                    type: 'email',
                    placeholder: 'Secondary Email'
                },
                {
                    label: 'Primary Mobile',
                    key: 'mobile',
                    required: true,
                    placeholder: 'Primary Mobile'
                },
                {
                    label: 'Secondary Mobile',
                    key: 'secondaryMobile',
                    required: false,
                    placeholder: 'Secondary Mobile'
                },

                {
                    label: 'Pincode',
                    key: 'pincode',
                    required: true,
                    placeholder: 'pincode'
                },
                {
                    label: 'Address',
                    key: 'address',
                    required: true,
                    placeholder: 'Address',
                    span: 18
                },
                {
                    label: 'Country',
                    key: 'country',
                    required: true,
                    showSearch: true,
                    options: Countries,
                    keyAccessor: x => x.name,
                    valueAccessor: x => x.name,
                    placeholder: 'Country',
                    type: 'select',
                    onChange: val => {
                        setFieldsValue({ country: val })

                    }
                },
                {
                    label: 'State',
                    key: 'state',
                    required: true,
                    placeholder: 'State'
                },
                {
                    label: 'City',
                    key: 'city',
                    required: true,
                    placeholder: 'City'
                },
                {
                    label: 'Page Number',
                    key: 'pageNumber',
                    required: true,
                    placeholder: 'Page Number'
                },

                {
                    label: 'Contact Person',
                    key: 'contactPerson',
                    required: true,
                    placeholder: 'Contact Person',
                    hidden: !(getFieldValue('subscribeBy') == 'Person')
                },
                {
                    label: 'Designation',
                    key: 'designation',
                    required: true,
                    placeholder: 'Designation',
                    hidden: !(getFieldValue('subscribeBy') == 'Person')
                },
                {
                    label: 'Agency Name',
                    key: 'agencyName',
                    required: true,
                    placeholder: 'Agency Name',
                    hidden: !(getFieldValue('subscribeBy') == 'Person')
                },

                // removed End User Address Field
                //   label: 'End User Address',
                //   key: 'endUserAddress',
                //   placeholder: 'End User Address'
                // ,



                {
                    label: 'Institute Name',
                    key: 'instituteName',
                    placeholder: 'Institute Name',
                    hidden: true

                },
                {
                    label: 'Institute Contact Person',
                    key: 'instituteContactPerson',
                    placeholder: 'Institute Contact Person',
                    hidden: true

                },
                {
                    label: 'Institute Address',
                    key: 'instituteAddress',
                    placeholder: 'Institute Address',
                    hidden: true

                },
                {
                    label: 'Institute Contact No',
                    key: 'instituteContactNo',
                    placeholder: 'Institute Contact No',
                    hidden: true
                },

                {
                    label: 'Year',
                    key: 'year',
                    type: 'select',
                    options: this.state.distinctYears,
                    allowClear: true,
                    placeholder: 'Year',
                    required: true,
                    keyAccessor: x => x,
                    valueAccessor: x => x,
                    onChange: (val) => {
                        setFieldsValue({ year: val })
                    }

                }

            ],

            multiFields: [
                {
                    label: 'Year',
                    key: 'year',
                    type: 'select',
                    hidden: !this.props.showAddJournal,
                    options: this.state.distinctYears,
                    allowClear: true,
                    placeholder: 'Year',
                    keyAccessor: x => x,
                    valueAccessor: x => x,
                    onChange: (val) => {
                        setFieldsValue({ year: val })
                    }
                },
                {
                    label: 'Journal of Interest',
                    key: 'journals',
                    showSearch: true,
                    hidden: !this.props.showAddJournal,
                    options: this.state.journalList,
                    keyAccessor: x => x._id,
                    valueAccessor: x => x.name,
                    placeholder: 'Journal',
                    type: 'select',
                    onChange: val => {
                        setFieldsValue({ journals: val, volume: undefined, issue: undefined })
                        const selectedJournalId = val && val
                        const relatedYears = subscriptionData[selectedJournalId] && subscriptionData[selectedJournalId].map(item => item.year) || []
                        this.setState({ yearOptions: relatedYears, journalVolumeList: [], journalIssueList: [] })
                        this.getJournalsVolumeData(val)

                    }

                },
                {
                    label: 'Copies',
                    key: 'copies',
                    hidden: !this.props.showAddJournal,
                    type: 'select', options: copiesList,
                    onChange: val => {
                        setFieldsValue({ copies: val })
                    }
                },
                /*   {
                       label: 'Volume',
                       key: 'volume',
                       hidden: !this.props.showAddJournal,
                       placeholder: 'Volume',
                       type: 'select',
                       options: this.state.journalVolumeList,
                       keyAccessor: x => x.name,
                       valueAccessor: x => x.name,
                       onChange: async (val) => {
                           this.setState({ volume: val, issue: undefined });
                           setFieldsValue({ volume: val, issue: undefined })
                           const selectedObj = this.state.journalVolumeList.find(x => x.name === val)
                           if (selectedObj) {
                               await this.getJournalsIssueData(selectedObj._id)
                           }
                       }
                   },
                   {
                       label: 'Issue',
                       key: 'issue',
                       hidden: !this.props.showAddJournal,
                       placeholder: 'Issue',
                       type: 'select',
                       options: this.state.journalIssueList,
                       keyAccessor: x => x.name,
                       valueAccessor: x => x.name,
                       onChange: val => {
                           this.setState({ issue: val });
                           setFieldsValue({ issue: val })
                       }
                   },*/


                {
                    key: 'add',
                    span: 4,
                    hidden: !this.props.showAddJournal,
                    customField: (
                        <InputBox title={'Add'} >
                            <a className='btn ' type='primary'
                                onClick={() => {
                                    this.AddSubscriptionDetails()
                                }}
                                style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white', marginBottom: '6px' }}>
                                ADD
                            </a>
                        </InputBox>
                    )
                }
            ]



        }

        const { multiFields } = inputSchma || {};

        const assignColumns = [
            {
                title: 'Journal Name',
                key: 'journalName',
                dataIndex: 'journalName',
                render: (text, record) => {
                    if (text) return text;
                    try {
                        const list = this.state.journalList || [];
                        let id = record.journals || record.journalId;
                        if (id && typeof id === 'object') id = id._id || id.id || id;

                        const found = list.find(j => j._id == id || j._id.toString() == id);
                        return found ? found.name : '';
                    } catch (e) { return ''; }
                }
            },
            {
                title: 'Copies',
                key: 'copies',
                dataIndex: 'copies'
            },
            /* {
                 title: 'Volume',
                 key: 'volume',
                 dataIndex: 'volume',
                 render: (text, record) => {
                     let val = text || record.volume || record.volumeName || record.vol;
                     if (val && typeof val === 'object') {
                         val = val.name || val.volumeName || val.label;
                     }
                     return val || '-';
                 }
             },
             {
                 title: 'Issue',
                 key: 'issue',
                 dataIndex: 'issue',
                 render: (text, record) => {
                     let val = text || record.issue || record.issueName || record.issues || record.issue_name;
                     if (val && typeof val === 'object') {
                         val = val.name || val.issueName || val.label;
                     } else if (Array.isArray(val)) {
                         val = val.map(v => (typeof v === 'object' ? v.name : v)).join(', ');
                     }
                     return val || '-';
                 }
             },*/


            {
                title: 'Action',
                key: 'action',
                dataIndex: 'action',
                render: (item, record, index) => {
                    return (
                        <Icon type={'close'}
                            style={{ color: 'red' }}
                            onClick={() => {
                                this.events.removeStateCountry(index)
                            }} />
                    )
                }
            }

        ]

        return (
          <Drawer
            title={this.props.showAddJournal ? 'Generate Invoice' : 'Edit Journal Subscription'}
            width={'60%'}
            visible={this.props.visible}
            maskClosable={true}
            placement='right'
            onClose={this.props.onClose}>
              <Card bordered={true}>
                  <Form
                    onSubmit={this.handleSubmit}
                    hideRequiredMark
                    noValidate={true}
                    className={'inputForm'}>
                      <Card bordered={true} size={'small'}>
                          <Row gutter={16}>
                              {inputSchma.fields.map((item, key) => {
                                  return (
                                    !item.hidden && !this.props.showAddJournal && (
                                      <Col
                                        span={item.span ? item.span : 6}
                                        md={item.span ? item.span : 6}
                                        sm={12}
                                        xs={24}
                                        key={key}>
                                          {item.customField ? (
                                            item.customField
                                          ) : (
                                            <GetEachFormFields
                                              item={item}
                                              getFieldDecorator={getFieldDecorator}
                                              formItemLayout={formItemLayout}
                                            />
                                          )}
                                      </Col>
                                    )
                                  )
                              })}
                          </Row>
                          <Row gutter={16}>
                              {inputSchma.multiFields.map((item, key) => {
                                  return (
                                    !item.hidden && (
                                      <Col
                                        span={item.span ? item.span : 6}
                                        md={item.span ? item.span : 6}
                                        sm={8}
                                        xs={24}
                                        key={key}>
                                          {item.customField ? (
                                            item.customField
                                          ) : (
                                            <GetEachFormFields
                                              item={item}
                                              getFieldDecorator={getFieldDecorator}
                                              formItemLayout={formItemLayout}
                                            />
                                          )}
                                      </Col>
                                    )
                                  )
                              })}
                          </Row>
                      </Card>

                      <Card className={'mt10'} size={'small'}>
                          <Table dataSource={this.state.amountDetails}
                                 className={'table table-bordered'}
                                 bordered={true} size={'small'}
                                 pagination={false} columns={assignColumns} />
                      </Card>


                      <div className={'d-flex jcsb'}>
                          <Form.Item className={'mt10'}>
                              <Button type='primary' htmlType='submit'>
                                  SUBMIT
                              </Button>
                          </Form.Item>
                          {this.state && this.state.amountDetails && this.state.amountDetails.length > 0 && (
                            <>

                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    margin: '16px 0',
                                    marginTop: '0px'
                                }}>
                                    <div style={{ padding: '12px', background: '#f5f5f5', borderRadius: '4px' }}>

                                        <p style={{ margin: 0, fontWeight: 'bold' }}>
                                            Total Amount - INR {this.state && (this.state.totalAmount || 0)}
                                        </p>
                                    </div>
                                </div>
                            </>
                          )}
                      </div>

                  </Form>


                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps,
    mapDispatchToProps
)(EditGeneralSubscriptionDrawer)
